import { useStore } from '@kundinos/nanostores/react';

import { modulesStore } from './stores';

import type { ModuleProductData } from '@Types/ModuleProduct';

function useModules() {
  return useStore(modulesStore) as ModuleProductData[];
}

export default useModules;
